export default function Index(imageUrl) {
  const logoContent = `  
      <img
        src='${imageUrl}'
        alt="logo"
        height="49"
      />`;
  return logoContent;
}
